<template>
  <div class="modal-content-event">
    <div class="modal-header">
      <h2>Nova objava</h2>
    </div>
    <div class="body">
      <form action="post">
        <div id="first-section">
          <div id="description-area">
            <label class="col-form-label col-form-label-lg">Tekst</label>
            <textarea
              class="form-control"
              rows="4"
              placeholder="Unesite tekst"
              v-model.trim="description"
              @focus="errorOccurred = false"
            ></textarea>
          </div>
          <div id="upload-area">
            <upload-button
              @files-selected="getFiles"
              ref="uploadBtn"
            ></upload-button>
            <div
              id="uploaded-files"
              :class="{ 'pointer-cursor': files.length == 0 }"
              @click="addFile"
              @dragover.prevent
              @dragleave.prevent
              @drop="onDrop"
            >
              <div class="upload-wrapper" v-if="files.length == 0">
                <svg
                  class="upload-icon pointer-cursor"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="33"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <label class="upload-text pointer-cursor"
                  >Izaberite datoteku</label
                >
              </div>
              <!-- <div id="empty-files" v-if="files.length == 0">
                <p>Trenutno nemate dodatih datoteka</p>
              </div>-->
              <div class="file" v-for="(file, index) of files" :key="index">
                <p>{{ file.name }}</p>
                <i
                  class="fas fa-times del--mod"
                  @click="removeUploadedFile(index)"
                ></i>
              </div>
              <div
                class="upload-more-wrapper pointer-cursor"
                @click="addMoreFiles"
                v-if="files.length > 0"
              >
                <svg
                  class="upload-more-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <span class="upload-more-text">Dodaj datoteku</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="submitMedia"
          :disabled="loading"
        >
          <span v-if="!loading">Potvrdi</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { Settings, DateTime } from 'luxon';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  components: {
    uploadButton
  },
  created() {
    Settings.defaultLocale = 'sr-Latn-CS';
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      description: '',
      files: [],
      removingFile: false
    };
  },
  computed: {
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getPostsByCommunity']),

    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.files.push(...files);
    },
    addFile() {
      if (this.files.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    getFiles(load) {
      for (let l of load) {
        this.files.push(l);
      }
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.files.splice(index, 1);
    },
    submitMedia() {
      this.errorOccurred = false;

      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }

      if (this.files.length == 0) {
        this.submitEvent();
        return;
      }
      this.loadingStarted();

      axios
        .post('/media/add', this.formatMediaForSubmit(), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(data => {
          this.submitEvent(data);
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        fd.append('files[]', this.files[i], this.files[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );

      return fd;
    },
    validateInput() {
      if (this.description == '') {
        this.errorMessage = 'Morate uneti tekst';
        return false;
      }

      if (this.description.length > 1000) {
        this.errorMessage = 'Tekst ne može imati više od 1000 karaktera';
        return false;
      }
      return true;
    },
    submitEvent(data) {
      let postData = {
        body: this.description,
        community_id: this.$store.getters.getActiveCommunity.community_id,
        direct_post_receiver_id: 0,
        event: null,
        media_ids: data ? data.data.ids : '',
        member_id: this.$store.getters.getActiveCommunity.member_id,
        parent_post_id: 0,
        post_type: 1,
        voting: null
      };

      this.loadingStarted();

      axios
        .post('/post', postData)
        .then(() => {
          this.loadingFinished();
          this.getPostsByCommunity(this.$route.params.id);
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    }
  }
};
</script>

<style lang="scss">
.pac-container {
  z-index: 999999;
}

.pac-logo::after {
  display: none;
}

.pac-item:hover {
  cursor: pointer;
  background-color: rgb(231, 231, 231);
}
.modal-content-event {
  .body {
    height: 100%;
    width: 100%;
  }
  input.vdatetime-input.form-control.form-control-lg {
    font-size: 1rem !important;
  }
  input {
    margin-bottom: 9px;
    position: relative;
  }
  #first-section {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  #date-area {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  .date {
    width: 50%;
  }

  textarea.form-control {
    resize: none;
    width: 100%;
  }

  #description-area {
    width: 66%;
  }

  #upload-area {
    display: block;
    margin-left: 9px;
    width: 34%;
    height: 100%;
  }

  #uploaded-files {
    border: 1px dotted var(--primary-color);
    border-radius: 0.25rem;
    height: 110px;
    resize: none;
    max-height: 134px;
    overflow-y: auto;
    padding: 5px;
  }

  .minus--mod {
    margin-left: 5px;
    font-size: 17px;
    color: grey;
    transition: color 0.25s;
  }

  .minus--mod:hover {
    cursor: pointer;
    color: #ff837b;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }
  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  #add-file-label {
    display: inline-flex;
  }

  #add-file-label:hover {
    display: inline-flex;
    cursor: pointer;
    color: var(--primary-color);
    transition: color 0.25s;
  }

  .del--mod {
    margin-left: auto;
    /*margin-right: 0;*/
    cursor: pointer;
    color: red;
    top: 4.7em;
    right: 1.7em;
  }

  #empty-files {
    text-align: center;
    color: grey;
    margin-top: 15%;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    vertical-align: center;
    p {
      max-width: 155px;
      word-wrap: break-word;
      margin-bottom: 2px;
    }
  }

  #map-area {
    margin-top: 5px;
  }

  .map {
    position: relative;
    margin-bottom: 5px;
    .marker {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -60px;
      margin-left: -30px;
    }
  }

  .map-desc {
    margin-top: 10px;
  }

  .chosen-place {
    display: inline-flex;
  }
}
</style>
